import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-unreported-outage-help',
  template: `
    <div class="e-flex e-flex-direction-column e-align-items-start e-gap-8">
      <p>Opplever du strømbrudd, men finner det ikke i kartet?</p>
      <a
        class="e-link e-link--sm e-link--new-tab"
        href="https://www.elvia.no/drift-og-vedlikehold/strombrudd/jeg-har-strombrudd-hva-gjor-jeg/"
        target="_blank"
        rel="noopener noreferrer">
        <span class="e-link__title">Jeg har strømbrudd, hva gjør jeg?</span>
        <span class="e-link__icon">
          <e-icon name="newTabBold" />
        </span>
      </a>
    </div>
  `,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UnreportedOutageHelpComponent {}
